import { render } from "./ModalLayout.vue?vue&type=template&id=4bada63e&scoped=true&ts=true&lang=pug"
import script from "./ModalLayout.vue?vue&type=script&lang=ts"
export * from "./ModalLayout.vue?vue&type=script&lang=ts"

import "./ModalLayout.vue?vue&type=style&index=0&id=4bada63e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bada63e"]])

export default __exports__